import { useEffect, useState } from "react";

let deferred = null;
const listeners = new Set();
window.addEventListener("beforeinstallprompt", (e) => {
  e.preventDefault();
  deferred = e;
  listeners.forEach((fn) => fn());
});
window.addEventListener("appinstalled", () => {
  deferred = null;
  localStorage.setItem("btp_installed", "1");
  listeners.forEach((fn) => fn());
});

export const isStandalone = () =>
  window.matchMedia?.("(display-mode: standalone)").matches || window.navigator.standalone === true;
export const isIOS = () => /iphone|ipad|ipod/i.test(navigator.userAgent);

export function useInstall() {
  const [, force] = useState(0);
  useEffect(() => {
    const fn = () => force((n) => n + 1);
    listeners.add(fn);
    return () => listeners.delete(fn);
  }, []);
  const install = async () => {
    if (!deferred) return false;
    deferred.prompt();
    const { outcome } = await deferred.userChoice;
    deferred = null;
    force((n) => n + 1);
    return outcome === "accepted";
  };
  return {
    installed: isStandalone() || localStorage.getItem("btp_installed") === "1",
    canPrompt: !!deferred,
    ios: isIOS(),
    install,
  };
}
